import { useState, useEffect } from "react";
import ApiService from "../utils/ApiService";
import { getEnvironment } from "../utils/EnvConfig";
//This hook will be deleted in future
const useFetchPaymentMethod = (params = {}) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getResponse();
  }, []);
  const getResponse = async () => {
    const env = getEnvironment();
    ApiService.get({ ...params, apiUrl: env.brightspeedApi }, {}, {}).then(
      (result) => {
        setData(result.data);
      }
    );
  };
  const reload = async () => {
    await getResponse();
  };
  return [data, reload];
};

// it's for re-fetch data when user add/edit payment method
export const reFetchListOfPaymentMethods = async (
  params = {},
  headers = {}
) => {
  const env = getEnvironment();
  return await ApiService.get(
    { ...params, apiUrl: env.brightspeedApi },
    { headers: headers }
  );
};

export const nonAuthListOfPaymentMethods = async (
  params = {},
  body = {},
  headers = {},
) => {
  const env = getEnvironment();
  return await ApiService.post(
    { ...params, apiUrl: env.brightspeedApi },
    body,
    { headers: headers }
  );
};


export default useFetchPaymentMethod;
